module.exports = __webpack_public_path__ + "img/humidity.01c6b9f5.png";